module.exports = __webpack_public_path__ + "img/data.363b2d7e.png";